module.exports = __webpack_public_path__ + "static/media/Location-red.4b1558a5.svg";